import { forwardRef } from 'react';

const Card = forwardRef(({
  children,
  className = '',
  hover = false,
  onClick,
  ...props
}, ref) => {
  const baseClasses = hover ? 'glass-card-hover' : 'glass-card';
  const interactiveClasses = onClick ? 'cursor-pointer' : '';

  return (
    <div
      ref={ref}
      className={`${baseClasses} ${interactiveClasses} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
});

Card.displayName = 'Card';

export default Card;
